/** Presentation attribute → storage autofill `field`. */
const ATTR_TO_FIELD = {
    legal_name: 'legal_name',
    id_number: 'id_number',
    email: 'email',
    phone: 'phone',
    address: 'composed_address',
    street: 'address_line1',
    postal_line: 'postal_address',
    postal_code: 'postal_code',
    city: 'city',
};
export function attrToAutofillField(attr) {
    return ATTR_TO_FIELD[attr];
}
/** Default editor input type per attribute. */
export function defaultTypeForAttr(attr) {
    return attr === 'address' ? 'textarea' : 'text';
}
/** Single-line postal address "123 45 Ort" (lokalhyra). */
const POSTAL_LINE_LABEL = 'Postnummeradress';
const ID_LABEL = {
    person: 'Personnummer',
    org: 'Organisationsnummer',
    unknown: 'Personnr / Org.nr',
};
const BASE_LABEL = {
    legal_name: 'Namn',
    email: 'E-post',
    phone: 'Telefon',
    address: 'Adress',
    street: 'Gatuadress',
    postal_line: POSTAL_LINE_LABEL,
    postal_code: 'Postnummer',
    city: 'Ort',
};
/** Canonical label for a party attribute, before any per-slot suffix. */
export function partyLabel(attr, idHint) {
    if (attr === 'id_number')
        return ID_LABEL[idHint ?? 'unknown'];
    return BASE_LABEL[attr];
}
/** Standard co-tenant disambiguation suffix (kills "(hyresgäst 2)" drift). */
export const COTENANT_SUFFIX = ' (medhyresgäst)';
/**
 * Canonical property labels (per ADR-0065). `address` defaults to
 * "Postadress" but is legitimately overridden per template to describe the
 * let object ("Lokalens adress", "Bilplatsens adress", …).
 */
export const PROPERTY_LABELS = {
    designation: 'Fastighetsbeteckning',
    kommun: 'Kommun',
    address: 'Postadress',
};
//# sourceMappingURL=vocabulary.js.map